import { render, staticRenderFns } from "./FontFromFile.vue?vue&type=template&id=77f99726"
import script from "./FontFromFile.vue?vue&type=script&lang=js"
export * from "./FontFromFile.vue?vue&type=script&lang=js"
import style0 from "./FontFromFile.vue?vue&type=style&index=0&id=77f99726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports